import { mapMutations, mapGetters } from "vuex";
import { giftItemQuantity } from "../../api/helpers/shoppingCartHelper.js";
export default {
  computed: {
    ...mapGetters(["giftCartItems"]),
    totalPrice() {
      let sum = this.price;
      return sum * this.quantity;
    },
    cartQuantity() {

      var item = { id: this.productId };
      const iq = giftItemQuantity(item, this.messageModel, this.giftCartItems);
      return iq + this.quantity;
    },
    maxQuantity() {
      var item = { id: this.productId };
      const iq = giftItemQuantity(item, this.messageModel, this.giftCartItems);
      return this.maxItemQuantity - iq;
    }
  },
  methods: {
    ...mapMutations(["Add_GiftcartItem"]),
    closeModal() {
      this.$parent.closeModal();
    },
    fixQuantity() {
      if (this.cartQuantity > this.maxItemQuantity) this.quantity = this.maxQuantity;
      if (this.quantity == 0)
        this.quantity = 1;
      return "";
    },
    closeModalMobile() {
      this.$nextTick(() => {
        this.$parent.closeModal();
      });
    },
    distinct(value) {
      let unique = {};
      value.forEach(function (x) {
        if (!unique[x.ID]) {
          //strict
          Object.defineProperty(unique, x.ID, { value: x, enumerable: true });
        }
      });

      return Object.values(unique);
    },
    inc() {
      this.quantity++;
    },
    dec() {
      this.quantity--;
    },
    addToCart() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.Add_GiftcartItem({
            item: {
              id: this.productId,
              code: this.product.ProductCode,
              name: this.product.Name,
              description: this.product.ShortDescription,
              photoUrl: this.product.PhotoUrl,
              tax: this.product.TaxRate,
              price: this.price
            },
            quantity: this.quantity,
            message: this.messageModel
          });
        }
        this.quantity = this.maxQuantity;
      });

    },
    addToCartMobile() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.Add_GiftcartItem({
            item: {
              id: this.productId,
              code: this.product.ProductCode,
              name: this.product.Name,
              description: this.product.ShortDescription,
              photoUrl: this.product.PhotoUrl,
              tax: this.product.TaxRate,
              price: this.price
            },
            quantity: this.quantity,
            message: this.messageModel
          });
        }
        this.$nextTick(() => {
          this.$parent.closeModal();
        });
      });
    }
  }
};
